<template>
  <div class="cp-backoffice-navigation has-background-primary">
    <img :src="company.logo_image_white" width="100" />
    <div class="cp-backoffice-navigation-language-selection">
      <!-- <b-button
        rounded
        :outlined="locale === 'en_US'"
        :class="locale === 'en_US' ? ['has-background-primary', 'has-text-white'] : ''"
        @click="updateLocale('th_TH')"
        >TH</b-button
      >
      <b-button
        rounded
        :outlined="locale === 'th_TH'"
        :class="locale === 'th_TH' ? ['has-background-primary', 'has-text-white'] : ''"
        @click="updateLocale('en_US')"
        >EN</b-button
      > -->
      <b-button
        type="is-warning is-light"
        rounded
        icon-pack="fas"
        icon-left="sign-out-alt"
        @click="showSignoutModal"
        >{{ $t('backoffice.navigation.signout') }}</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { logout } from '@/apis/user';
import ConfirmModal from '@/components/backoffice/ConfirmModal.vue';

export default {
  name: 'Navigation',
  data() {
    return {
      locale: '',
    };
  },
  computed: mapState({
    company: state => state.company,
    contact: state => state.contact,
  }),
  methods: {
    updateLocale(locale) {
      this.$store.commit('updateLocale', locale);
    },
    showSignoutModal() {
      this.$buefy.modal.open({
        parent: this,
        component: ConfirmModal,
        props: {
          title: this.$t('backoffice.navigation.modal.signout.title'),
          ok: this.$t('backoffice.navigation.modal.signout.ok'),
          cancel: this.$t('backoffice.navigation.modal.signout.cancel'),
        },
        events: {
          ok: this.signout,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async signout() {
      try {
        await logout();

        this.$router.replace({
          name: 'BackofficeLoginView',
        });
      } catch (error) {
        this.$buefy.snackbar.open({
          message: this.$t('snackbar.error.message'),
          type: 'is-danger',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 3000,
        });
      }
    },
  },
  mounted() {
    this.locale = this.$cookies.get('locale') || 'th_TH';
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cp-backoffice-navigation {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;

  &-language-selection {
    display: flex;

    button {
      margin-left: 5px;
    }
  }
}
</style>
